export const getTransactions = (state) => {
    return state.status.transactions.txs;
};
